<div ngbDropdown class="month-picker" #myDrop="ngbDropdown" (openChange)="onDropdownToggle($event)">
    <div class="position-relative">
        <input type="text" class="form-control" placeholder="mmm-yyyy" id="dropdownBasic1" ngbDropdownToggle readonly
            [(ngModel)]="selectedDate" />
        <i class="fa-regular fa-calendar postfix text-brightPurple"></i>
    </div>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <div class="year-picker d-flex justify-content-between align-items-center mb-2 px-2">
            <button [disabled]="previousDisabled()" class="btn btn-secondary btn-picker prev p-1 border-0" (click)="previousYear()">
                <i class="fa-solid fa-chevron-left me-2"></i>
            </button>
            <span class="pointer year-selection" (click)="changeView()">
                <span class="h5 mb-0">{{ yearView ? years[0]+' - '+years[years.length-1] : currentYear }}</span>
                <i class="fa-solid ms-1" [ngClass]="{'fa-caret-down': !yearView, 'fa-caret-up': yearView}" ></i>
            </span>
            <button [disabled]="nextDisabled()" class="btn btn-secondary btn-picker next p-1 border-0" (click)="nextYear()">
                <i class="fa-solid fa-chevron-right ms-2"></i>
            </button>
        </div>

        <div class="calendar-grid">
            <ng-container *ngIf="yearView; else monthView">
                <div class="month-grid px-2">
                    <div *ngFor="let year of years; let i = index" class="month-item year" [ngClass]="{'selected': year == selectedYear}" (click)="selectYear(year)">
                        <span>{{ year }}</span>
                    </div>
                </div>
            </ng-container>
            <ng-template #monthView>
                <div class="month-grid px-2">
                    <div *ngFor="let month of months; let i = index" [disabled]="monthDisabled(i)" class="month-item month" [ngClass]="{'selected': currentYear == selectedYear && month.name == selectedMonth}" (click)="selectMonth(i)" ngbDropdownItem>
                        <span>{{ month.name }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>